import { PulseBaseProvider } from '../../base-classes';

const _weekdayWeekendCacheKey = 'weekdayWeekend';
const _weekdayWeekendUri = (type, location) => `/api/wewd/v1/forecast/locationType=${type}/location=${location}`;

export class WeekdayWeekendProvider extends PulseBaseProvider {

    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
        this.storage.sync[_weekdayWeekendCacheKey] = this.getWeekdayWeekendForecastSyncer.bind(this);
    }

    async getWeekdayWeekendForecastSyncer(params) {
        const { id, syncParams, resolve, reject } = params;
        const uri = _weekdayWeekendUri('LatitudeLongitude', `${syncParams.latitude},${syncParams.longitude}`)
        const queryParams = {
            ...syncParams.stdParameters,
            temperatureUnit: syncParams.temperatureUnit,
            speedUnit: syncParams.speedUnit,
            cultureInfo: syncParams.cultureInfo,
            verbose: syncParams.verbose
        };

        const responseValidator = response => {
            return !!response;
        };

        return await super.syncData(syncParams.key, id, queryParams, uri, resolve, reject, responseValidator, syncParams.pulseApi);
    }

    async getWeekdayWeekendForecast(latitude, longitude, stdParameters, temperatureUnit , speedUnit , cultureInfo, verbose = false, refresh = false) {
        const syncParams = {
            latitude,
            longitude,
            temperatureUnit,
            speedUnit,
            cultureInfo,
            verbose: !!verbose,
            refresh
        };
        const id = JSON.stringify(syncParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(_weekdayWeekendCacheKey, id);
        }
        return await super.loadFromStorage(_weekdayWeekendCacheKey, id, syncParams);
    }
}
